// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./Login.css";
// import logo from "./assets/snap4me_logo.png";
// import loginBackground from "./assets/login-dashboard.png";

// const API_URL = process.env.REACT_APP_API_URL;

// function Login({ onApiLoginSuccess, onLocalLoginSuccess }) {
//   const navigate = useNavigate();

//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState("");

//   const handleLogin = async (e) => {
//     e.preventDefault();

//     setError("");
//     setIsLoading(true);

//     if (!email || !password) {
//       setError("Please fill in all required fields.");
//       setIsLoading(false);
//       return;
//     }

//     try {
//       const response = await fetch(`${API_URL}/api/login`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           email,
//           password,
//         }),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(
//           data.detail ||
//             data.message ||
//             "Invalid email or password."
//         );
//       }

//       const userData = data.user;
//       const jwt = data.jwt;

//       if (!jwt) {
//         throw new Error("Login response is missing user or JWT.");
//       }

//       localStorage.setItem("jwt", jwt);
//       localStorage.setItem("user", JSON.stringify(userData));
//       localStorage.setItem("localUser", JSON.stringify(userData));

//       if (onApiLoginSuccess) {
//         onApiLoginSuccess(userData, "techzeus");
//       }

//       navigate("/dashboard");
//     } catch (loginError) {
//       console.error("Login failed:", loginError);

//       setError(
//         loginError.message ||
//           "Invalid email or password. Please try again."
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="dashboard-login-root">

//       {/* LEFT PANEL */}
//      <div
//         className="dashboard-login-hero"
//         style={{
//         backgroundImage: `
//           linear-gradient(to bottom right, rgba(47, 49, 52, 1), rgba(55, 114, 255, 0.46)), 
//           url(${loginBackground})
//         `,
//       }}
//       >
//         <div className="hero-content">

//           <div className="brand-header">
//             <img
//               src={logo}
//               alt="Snap4Me Logo"
//               className="brand-logo-img"
//             />
//           </div>

//           <div className="hero-body">
//             <span className="hero-eyebrow">
//               BUSINESS DASHBOARD CENTER
//             </span>

//             <h2>
//               Automated Report
//               <br />
//               <span>& Document Compiler</span>
//             </h2>

//             <p>
//               Access multi-job report compilation, customize
//               document layouts, and manage job entities from
//               your central control deck.
//             </p>

//             <div className="hero-feature-list">
//               <div className="hero-feature">
//                 <span className="feature-icon">✓</span>
//                 <span>Automated document generation</span>
//               </div>

//               <div className="hero-feature">
//                 <span className="feature-icon">✓</span>
//                 <span>Multi-job batch processing</span>
//               </div>

//               <div className="hero-feature">
//                 <span className="feature-icon">✓</span>
//                 <span>Centralized report management</span>
//               </div>
//             </div>
//           </div>

//           <div className="hero-metrics-card">

//             <div className="metric-item">
//               <span className="metric-val">100%</span>
//               <span className="metric-lbl">
//                 Automated Docs
//               </span>
//             </div>

//             <div className="metric-divider"></div>

//             <div className="metric-item">
//               <span className="metric-val">Multi-Job</span>
//               <span className="metric-lbl">
//                 Batch Export
//               </span>
//             </div>

//             <div className="metric-divider"></div>

//             <div className="metric-item">
//               <span className="metric-val">24/7</span>
//               <span className="metric-lbl">
//                 Availability
//               </span>
//             </div>

//           </div>
//         </div>

//         <div className="hero-footer-text">
//           Snap4Me Enterprise Engine • System v2.4.0
//         </div>

//       </div>

//       {/* RIGHT PANEL */}
//       <div className="dashboard-login-panel">

//           <div className="login-panel-inner">

//         <div className="right-panel-logo">
//           <img
//             src={logo}
//             alt="Snap4Me"
//           />
//         </div>

//         <div className="form-card">

//           <div className="form-header">
           
//             <h1>Sign in to Dashboard</h1>

//             <p>
//               Enter your credentials to continue
//             </p>
//           </div>

//           {/* ERROR */}
//           {error && (
//             <div className="dashboard-error-banner">
//               <span className="error-icon">⚠️</span>
//               <span>{error}</span>
//             </div>
//           )}

//           {/* LOGIN FORM */}
//           <form
//             onSubmit={handleLogin}
//             className="dashboard-form"
//           >

//             {/* EMAIL */}
//             <div className="input-field-group">
//               <label htmlFor="email">
//                 Email
//               </label>

//               <div className="input-wrapper">
//                 <span className="input-icon">&#x2709;</span>

//                 <input
//                   id="email"
//                   type="email"
//                   placeholder="operator@company.com"
//                   value={email}
//                   onChange={(e) =>
//                     setEmail(e.target.value)
//                   }
//                   disabled={isLoading}
//                   required
//                 />
//               </div>
//             </div>

//             {/* PASSWORD */}
//             <div className="input-field-group">

//               <div className="label-with-action">
//                 <label htmlFor="password">
//                   Password
//                 </label>
//               </div>

//               <div className="password-input-wrapper">

//                 <span className="input-icon">●</span>

//                 <input
//                   id="password"
//                   type={
//                     showPassword
//                       ? "text"
//                       : "password"
//                   }
//                   placeholder="••••••••••••"
//                   value={password}
//                   onChange={(e) =>
//                     setPassword(e.target.value)
//                   }
//                   disabled={isLoading}
//                   required
//                 />

//                 <button
//                   type="button"
//                   className="password-toggle-btn"
//                   onClick={() =>
//                     setShowPassword(!showPassword)
//                   }
//                   tabIndex="-1"
//                 >
//                   {showPassword ? "Hide" : "Show"}
//                 </button>

//               </div>
//             </div>

//             {/* LOGIN BUTTON */}
//             <button
//               type="submit"
//               className="dashboard-submit-btn"
//               disabled={isLoading}
//             >
//               {isLoading ? (
//                 <span className="btn-loading-state">
//                   <span className="btn-spinner"></span>
//                   Authenticating...
//                 </span>
//               ) : (
//                 <>
//                   Authenticate
//                   <span className="btn-arrow">→</span>
//                 </>
//               )}
//             </button>

//           </form>

//           <div className="panel-footer">
//             <span className="footer-lock">🔒</span>
//             <p>
//               Protected area. Authorized personnel only.
//             </p>
//           </div>

//         </div>

//         </div>

//       </div>

//     </div>
//   );
// }

// export default Login;

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import logo from "./assets/snap4me_logo.png";
import loginBackground from "./assets/login-dashboard.png";

const API_URL =
  process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

function Login({ onApiLoginSuccess, onLocalLoginSuccess }) {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  // LOGIN AUDIT
  const recordLoginActivity = async (userData, jwt) => {
    try {
      if (!userData?.id || !jwt) {
        console.warn("LOGIN AUDIT: Missing user ID or JWT");
        return;
      }

      await fetch(`${API_URL}/api/auth/login-log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt}`,
          "X-User-ID": String(userData.id),
        },
      });

      console.log("LOGIN AUDIT: Login activity recorded");
    } catch (error) {
      // Audit logging must not break the actual login.
      console.error("LOGIN AUDIT ERROR:", error);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    setError("");
    setIsLoading(true);

    if (!email || !password) {
      setError("Please fill in all required fields.");
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.detail ||
            data.message ||
            "Invalid email or password."
        );
      }

      const userData = data.user;
      const jwt = data.jwt;

      if (!jwt) {
        throw new Error("Login response is missing user or JWT.");
      }

      // Store login information
      localStorage.setItem("jwt", jwt);
      localStorage.setItem("user", JSON.stringify(userData));
      localStorage.setItem("localUser", JSON.stringify(userData));

      // Record login audit activity
      await recordLoginActivity(userData, jwt);

      // Notify parent application
      if (onApiLoginSuccess) {
        onApiLoginSuccess(userData, "techzeus");
      }

      // Redirect after successful login
      navigate("/dashboard");
    } catch (loginError) {
      console.error("Login failed:", loginError);

      setError(
        loginError.message ||
          "Invalid email or password. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="dashboard-login-root">

      {/* LEFT PANEL */}
     <div
        className="dashboard-login-hero"
        style={{
        backgroundImage: `
          linear-gradient(to bottom right, rgba(47, 49, 52, 1), rgba(55, 114, 255, 0.46)), 
          url(${loginBackground})
        `,
      }}
      >
        <div className="hero-content">

          <div className="brand-header">
            <img
              src={logo}
              alt="Snap4Me Logo"
              className="brand-logo-img"
            />
          </div>

          <div className="hero-body">
            <span className="hero-eyebrow">
              BUSINESS DASHBOARD CENTER
            </span>

            <h2>
               Complete Campaign Visibility
              <br />
              <span>One Control Center</span>
            </h2>

            <p>
              Manage campaigns, brands, users, and field verification jobs from a single dashboard. Turn ground-level activities into actionable reports and insights.
            </p>

            <div className="hero-feature-list">
              <div className="hero-feature">
                <span className="feature-icon">✓</span>
                <span>Campaign & Job Monitoring - Track execution progress, submissions, and verification status.</span>
              </div>

              <div className="hero-feature">
                <span className="feature-icon">✓</span>
                <span>Discrepancy Detection - Identify missing evidence, location mismatches, and campaign execution gaps.</span>
              </div>

            </div>
          </div>

          <div className="hero-metrics-card">

            <div className="metric-item">
              <span className="metric-val">100%</span>
              <span className="metric-lbl">
                Automated Docs
              </span>
            </div>

            <div className="metric-divider"></div>

            <div className="metric-item">
              <span className="metric-val">Multi-Job</span>
              <span className="metric-lbl">
                Batch Export
              </span>
            </div>

            <div className="metric-divider"></div>

            <div className="metric-item">
              <span className="metric-val">24/7</span>
              <span className="metric-lbl">
                Availability
              </span>
            </div>

          </div>
        </div>

        <div className="hero-footer-text">
          Snap4Me Enterprise Engine • System v2.4.0
        </div>

      </div>

      {/* RIGHT PANEL */}
      <div className="dashboard-login-panel">

          <div className="login-panel-inner">

        <div className="right-panel-logo">
          <img
            src={logo}
            alt="Snap4Me"
          />
        </div>

        <div className="form-card">

          <div className="form-header">
           
            <h1>Sign in to Dashboard</h1>

            <p>
              Enter your credentials to continue
            </p>
          </div>

          {/* ERROR */}
          {error && (
            <div className="dashboard-error-banner">
              <span className="error-icon">⚠️</span>
              <span>{error}</span>
            </div>
          )}

          {/* LOGIN FORM */}
          <form
            onSubmit={handleLogin}
            className="dashboard-form"
          >

            {/* EMAIL */}
            <div className="input-field-group">
              <label htmlFor="email">
                Email
              </label>

              <div className="input-wrapper">
                <span className="input-icon">&#x2709;</span>

                <input
                  id="email"
                  type="email"
                  placeholder="operator@company.com"
                  value={email}
                  onChange={(e) =>
                    setEmail(e.target.value)
                  }
                  disabled={isLoading}
                  required
                />
              </div>
            </div>

            {/* PASSWORD */}
            <div className="input-field-group">

              <div className="label-with-action">
                <label htmlFor="password">
                  Password
                </label>
              </div>

              <div className="password-input-wrapper">

                <span className="input-icon">●</span>

                <input
                  id="password"
                  type={
                    showPassword
                      ? "text"
                      : "password"
                  }
                  placeholder="••••••••••••"
                  value={password}
                  onChange={(e) =>
                    setPassword(e.target.value)
                  }
                  disabled={isLoading}
                  required
                />

                <button
                  type="button"
                  className="password-toggle-btn"
                  onClick={() =>
                    setShowPassword(!showPassword)
                  }
                  tabIndex="-1"
                >
                  {showPassword ? "Hide" : "Show"}
                </button>

              </div>
            </div>
          



            {/* LOGIN BUTTON */}
            <button
              type="submit"
              className="dashboard-submit-btn"
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="btn-loading-state">
                  <span className="btn-spinner"></span>
                  Authenticating...
                </span>
              ) : (
                <>
                  Authenticate
                  <span className="btn-arrow">→</span>
                </>
              )}
            </button>
  {/* FORGOT PASSWORD */}
              <div className="forgot-password-wrapper">
                <button
                  type="button"
                  className="forgot-password-btn"
                  onClick={() => navigate("/forgot-password")}
                  disabled={isLoading}
                >
                  Forgot Password?
                </button>
              </div>
          </form>
                      

          <div className="panel-footer">
            <span className="footer-lock">🔒</span>
            <p>
              Protected area. Authorized personnel only.
            </p>
          </div>

        </div>

        </div>

      </div>

    </div>
  );
}

export default Login;